<!-- MF-1879 : onglet Google Agenda de la page Profil -->
<div class="col-xl-12 col-lg-12 col-sm-12 p-3 border-white rounded bg-light google-agenda">

  <div *ngIf="message" class="alert ga-alert" [ngClass]="'ga-alert-' + message.type" role="alert">
    <button type="button" class="close" aria-label="Fermer" (click)="closeMessage()">
      <span aria-hidden="true">&times;</span>
    </button>
    {{ message.text }}
  </div>

  <div class="d-flex align-items-center mb-3">
    <svg class="ga-icon mr-3" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/>
      <path d="M3 10h18M8 3v4M16 3v4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>
    <p class="mb-0 ga-intro">Ajoutez automatiquement vos visites planifiées à votre agenda Google.</p>
  </div>

  <div *ngIf="loading" class="cp-spinner cp-bubble" style="height: 30px;width: 30px;display: block;"></div>

  <ng-container *ngIf="!loading">

    <!-- Intégration non activée sur le serveur -->
    <p *ngIf="notConfigured" class="text-muted mb-0">
      L'intégration Google Agenda n'est pas encore activée. Contactez votre administrateur.
    </p>

    <ng-container *ngIf="!notConfigured">

      <!-- Non connecté -->
      <div *ngIf="!connected && !revoked">
        <ul class="ga-list mb-4">
          <li>Ajoutez automatiquement vos visites planifiées à votre agenda Google : elles sont mises à jour
          en cas de report et retirées en cas d'annulation</li>
          <li>Un report met à jour l'événement ; une annulation le supprime.</li>
          <li>MasterField n'a accès qu'aux événements de votre agenda, jamais à vos emails ni à vos contacts.</li>
        </ul>
        <button type="button" class="btn btn-gradient-dark btn-rounded pr-4 pl-4" (click)="connect()" [disabled]="actionLoading">
          <span *ngIf="actionLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
          Connecter mon compte Google
        </button>
      </div>

      <!-- Autorisation révoquée / expirée -->
      <div *ngIf="revoked" class="ga-revoked">
        <p class="mb-3">
          <strong>L'autorisation Google a expiré ou a été retirée.</strong><br>
          Vos visites ne sont plus synchronisées avec {{ status?.email || 'votre compte Google' }}.
        </p>
        <button type="button" class="btn btn-gradient-dark btn-rounded pr-4 pl-4 mr-2 mb-2" (click)="connect()" [disabled]="actionLoading">
          Reconnecter mon compte Google
        </button>
        <button type="button" class="btn btn-outline-danger btn-rounded mb-2" data-toggle="modal" data-target="#gaDisconnectModal" [disabled]="actionLoading">
          Supprimer la connexion
        </button>
      </div>

      <!-- Connecté -->
      <div *ngIf="connected">
        <div class="row mb-3">
          <p class="col-lg-3 col-md-4 col-sm-12 h6 mb-2">Compte connecté</p>
          <p class="col-lg-9 col-md-8 col-sm-12 h6 mb-2 ga-value">
            <span class="ga-dot mr-2"></span>{{ status?.email || 'Compte Google' }}
          </p>
        </div>

        <p class="ga-hint mb-3">Vos visites sont ajoutées à l'agenda principal de ce compte.</p>

        <div *ngIf="visitsInError.length > 0" class="ga-errors mb-3">
          <span>{{ visitsInError.length }} visite(s) n'ont pas pu être ajoutées à votre agenda.</span>
          <button type="button" class="btn btn-sm btn-outline-dark btn-rounded ml-3" (click)="retryAll()" [disabled]="retryLoading">
            <span *ngIf="retryLoading" class="spinner-border spinner-border-sm mr-1" role="status"></span>
            Relancer la synchronisation
          </button>
        </div>

        <div class="ga-actions">
          <button type="button" class="btn btn-outline-dark btn-rounded pr-4 pl-4" data-toggle="modal" data-target="#gaChangeAccountModal" [disabled]="actionLoading">
            <span *ngIf="actionLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
            Changer de compte
          </button>
          <button type="button" class="btn btn-outline-danger btn-rounded pr-4 pl-4" data-toggle="modal" data-target="#gaDisconnectModal" [disabled]="actionLoading">
            Déconnecter Google Agenda
          </button>
        </div>
      </div>

    </ng-container>
  </ng-container>
</div>

<!-- MF-1879 : popin de confirmation - changement de compte Google -->
<div class="modal fade" id="gaChangeAccountModal" tabindex="-1" role="dialog" aria-labelledby="gaChangeAccountLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="gaChangeAccountLabel">
          <img src="../../assets/img/google-calendar.png" alt="" class="mr-2"> 
          <b>Changer de compte Google</b></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <p>Vos visites seront retirées de l'agenda de :</p>
        <p><a href="javascript:void(0)" class="font-weight-bold text-primary">{{ status?.email || 'votre compte actuel' }}</a></p>
        <p class="mb-0">puis ajoutées à l'agenda du compte Google que vous allez choisir.</p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Non</button>
        <button type="button" class="btn btn-outline-success" data-dismiss="modal" (click)="changeAccount()">Oui, changer de compte</button>
      </div>
    </div>
  </div>
</div>

<!-- MF-1879 : popin de confirmation - déconnexion Google Agenda -->
<div class="modal fade" id="gaDisconnectModal" tabindex="-1" role="dialog" aria-labelledby="gaDisconnectLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="gaDisconnectLabel"><b>Déconnecter Google Agenda</b></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <p>Voulez-vous déconnecter le compte :</p>
        <p><a href="javascript:void(0)" class="font-weight-bold text-primary">{{ status?.email || 'Google' }}</a></p>
        <p class="mb-0">Vos nouvelles visites ne seront plus ajoutées à votre agenda Google.</p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Non</button>
        <button type="button" class="btn btn-outline-danger" data-dismiss="modal" (click)="disconnect()">Oui, déconnecter</button>
      </div>
    </div>
  </div>
</div>
